import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadFileTemplatesQueryVariables = {};


export type ReadFileTemplatesQuery = (
  { __typename?: 'Query' }
  & { fileTemplates: Array<(
    { __typename?: 'FileTemplate' }
    & Pick<Types.FileTemplate, '_id' | 'created' | 'modified' | 'fileName' | 'uri' | 'type' | 'cellMapping'>
    & { createdBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'roles'>
    ), modifiedBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'roles'>
    ), provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
    )> }
  )> }
);

export type CreateFileTemplateMutationVariables = {
  input: Types.FileTemplateInsertInput
};


export type CreateFileTemplateMutation = (
  { __typename?: 'Mutation' }
  & { createFileTemplate: (
    { __typename?: 'FileTemplate' }
    & Pick<Types.FileTemplate, '_id'>
  ) }
);

export type UpdateFileTemplateMutationVariables = {
  id: Types.Scalars['ID'],
  update: Types.FileTemplateUpdateInput
};


export type UpdateFileTemplateMutation = (
  { __typename?: 'Mutation' }
  & { updateFileTemplate: (
    { __typename?: 'FileTemplate' }
    & Pick<Types.FileTemplate, '_id'>
  ) }
);

export type DeleteFileTemplatesMutationVariables = {
  ids: Array<Types.Scalars['ID']>
};


export type DeleteFileTemplatesMutation = (
  { __typename?: 'Mutation' }
  & { deleteFileTemplates: Array<(
    { __typename?: 'FileTemplate' }
    & Pick<Types.FileTemplate, '_id'>
  )> }
);

export type GenerateFileFromTemplateMutationVariables = {
  templateUri: Types.Scalars['String'],
  mapping: Types.Scalars['String'],
  provingId: Types.Scalars['String'],
  isTestDoc?: Types.Maybe<Types.Scalars['Boolean']>
};


export type GenerateFileFromTemplateMutation = (
  { __typename?: 'Mutation' }
  & { generateFileFromTemplate: (
    { __typename?: 'Blob' }
    & Pick<Types.Blob, 'uri' | 'containerUri' | 'name'>
  ) }
);

export const ReadFileTemplatesDocument = gql`
    query ReadFileTemplates {
  fileTemplates(sort: {fileName: ASC}) {
    _id
    created
    createdBy {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      roles
    }
    modified
    modifiedBy {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      roles
    }
    fileName
    uri
    type
    cellMapping
    provingGround {
      _id
      title
    }
  }
}
    `;

    export function useReadFileTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadFileTemplatesQuery, ReadFileTemplatesQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadFileTemplatesQuery, ReadFileTemplatesQueryVariables>(ReadFileTemplatesDocument, baseOptions);
    };
      export function useReadFileTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadFileTemplatesQuery, ReadFileTemplatesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadFileTemplatesQuery, ReadFileTemplatesQueryVariables>(ReadFileTemplatesDocument, baseOptions);
      };
      
export type ReadFileTemplatesQueryHookResult = ReturnType<typeof useReadFileTemplatesQuery>;
export type ReadFileTemplatesQueryResult = ApolloReactCommon.QueryResult<ReadFileTemplatesQuery, ReadFileTemplatesQueryVariables>;
export const CreateFileTemplateDocument = gql`
    mutation CreateFileTemplate($input: FileTemplateInsertInput!) {
  createFileTemplate(input: $input) {
    _id
  }
}
    `;
export type CreateFileTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateFileTemplateMutation, CreateFileTemplateMutationVariables>;

    export function useCreateFileTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFileTemplateMutation, CreateFileTemplateMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateFileTemplateMutation, CreateFileTemplateMutationVariables>(CreateFileTemplateDocument, baseOptions);
    };
export type CreateFileTemplateMutationHookResult = ReturnType<typeof useCreateFileTemplateMutation>;
export type CreateFileTemplateMutationResult = ApolloReactCommon.MutationResult<CreateFileTemplateMutation>;
export type CreateFileTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFileTemplateMutation, CreateFileTemplateMutationVariables>;
export const UpdateFileTemplateDocument = gql`
    mutation UpdateFileTemplate($id: ID!, $update: FileTemplateUpdateInput!) {
  updateFileTemplate(id: $id, update: $update) {
    _id
  }
}
    `;
export type UpdateFileTemplateMutationFn = ApolloReactCommon.MutationFunction<UpdateFileTemplateMutation, UpdateFileTemplateMutationVariables>;

    export function useUpdateFileTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFileTemplateMutation, UpdateFileTemplateMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateFileTemplateMutation, UpdateFileTemplateMutationVariables>(UpdateFileTemplateDocument, baseOptions);
    };
export type UpdateFileTemplateMutationHookResult = ReturnType<typeof useUpdateFileTemplateMutation>;
export type UpdateFileTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateFileTemplateMutation>;
export type UpdateFileTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFileTemplateMutation, UpdateFileTemplateMutationVariables>;
export const DeleteFileTemplatesDocument = gql`
    mutation DeleteFileTemplates($ids: [ID!]!) {
  deleteFileTemplates(ids: $ids) {
    _id
  }
}
    `;
export type DeleteFileTemplatesMutationFn = ApolloReactCommon.MutationFunction<DeleteFileTemplatesMutation, DeleteFileTemplatesMutationVariables>;

    export function useDeleteFileTemplatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFileTemplatesMutation, DeleteFileTemplatesMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteFileTemplatesMutation, DeleteFileTemplatesMutationVariables>(DeleteFileTemplatesDocument, baseOptions);
    };
export type DeleteFileTemplatesMutationHookResult = ReturnType<typeof useDeleteFileTemplatesMutation>;
export type DeleteFileTemplatesMutationResult = ApolloReactCommon.MutationResult<DeleteFileTemplatesMutation>;
export type DeleteFileTemplatesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFileTemplatesMutation, DeleteFileTemplatesMutationVariables>;
export const GenerateFileFromTemplateDocument = gql`
    mutation GenerateFileFromTemplate($templateUri: String!, $mapping: String!, $provingId: String!, $isTestDoc: Boolean) {
  generateFileFromTemplate(templateUri: $templateUri, mapping: $mapping, provingId: $provingId, isTestDoc: $isTestDoc) {
    uri
    containerUri
    name
  }
}
    `;
export type GenerateFileFromTemplateMutationFn = ApolloReactCommon.MutationFunction<GenerateFileFromTemplateMutation, GenerateFileFromTemplateMutationVariables>;

    export function useGenerateFileFromTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateFileFromTemplateMutation, GenerateFileFromTemplateMutationVariables>) {
      return ApolloReactHooks.useMutation<GenerateFileFromTemplateMutation, GenerateFileFromTemplateMutationVariables>(GenerateFileFromTemplateDocument, baseOptions);
    };
export type GenerateFileFromTemplateMutationHookResult = ReturnType<typeof useGenerateFileFromTemplateMutation>;
export type GenerateFileFromTemplateMutationResult = ApolloReactCommon.MutationResult<GenerateFileFromTemplateMutation>;
export type GenerateFileFromTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateFileFromTemplateMutation, GenerateFileFromTemplateMutationVariables>;